import { formatAuLong, PAGE_UPDATED, SITE_ORIGIN } from "@/data/pageUpdated";
import { SchemaJsonLd } from "@/components/ls/SchemaJsonLd";

interface LastUpdatedProps {
  /** Route path key into PAGE_UPDATED, e.g. "/seo". */
  path: string;
  /** Page title used in the WebPage schema. */
  name: string;
  /** Optional: id prefix for the JSON-LD script tag. */
  schemaId?: string;
}

// Re-exported for the footer stamp so it doesn't need a second lookup module.
export { formatAuLong, PAGE_UPDATED };

/**
 * Visible "Last updated <date>" stamp + a WebPage JSON-LD block carrying
 * dateModified, both sourced from src/data/pageUpdated.ts.
 *
 * Drop this near the bottom of a cornerstone page (just before `</Layout>`).
 */
export function LastUpdated({ path, name, schemaId }: LastUpdatedProps) {
  const iso = PAGE_UPDATED[path];
  if (!iso) return null;
  const url = `${SITE_ORIGIN}${path === "/" ? "/" : path}`;
  // Visible "Last updated" stamp is rendered globally in the site footer
  // (see FooterLastUpdated in src/components/Footer.tsx). This component now
  // only emits the WebPage JSON-LD carrying dateModified, which needs to stay
  // per-page so schema is scoped to the current URL.
  return (
    <SchemaJsonLd
      id={schemaId ?? `webpage-${path.replace(/\W+/g, "-")}`}
      data={{
        "@context": "https://schema.org",
        "@type": "WebPage",
        "@id": `${url}#webpage`,
        url,
        name,
        dateModified: iso,
      }}
    />
  );
}

export default LastUpdated;
